import { makeGameControl, gameover } from '../gameControl'

export { gameover }
export default makeGameControl('shooting')
